import React from 'react';
export const ProductShowcaseSection = () => {
  const items = [{
    title: 'MODULE 1',
    name: 'Sharp Mind Workbook',
    icon: '🧠',
    color: 'bg-blue-500/20 border-blue-500/50'
  }, {
    title: 'MODULE 2',
    name: 'Move with Confidence',
    icon: '🦵',
    color: 'bg-green-500/20 border-green-500/50'
  }, {
    title: 'MODULE 3',
    name: 'Expert Care Protocol',
    icon: '🏥',
    color: 'bg-red-500/20 border-red-500/50'
  }, {
    title: 'MODULE 4',
    name: 'Vitality 360 Health Tracker',
    icon: '📋',
    color: 'bg-purple-500/20 border-purple-500/50'
  }, {
    title: 'MODULE 5',
    name: 'The Empowered Caregiver Guide',
    icon: '⭐',
    color: 'bg-yellow-500/20 border-yellow-500/50'
  }, {
    title: 'VIP MODULE',
    name: '150+ At-Home Exercises',
    icon: '⚡',
    color: 'bg-familia-cyan/20 border-familia-cyan/50'
  }, {
    title: 'BONUS 1',
    name: 'Vital Nutrition 60+',
    icon: '🍎',
    color: 'bg-orange-500/20 border-orange-500/50'
  }, {
    title: 'BONUS 2',
    name: 'Family Connection Kit',
    icon: '👥',
    color: 'bg-teal-500/20 border-teal-500/50'
  }, {
    title: 'BONUS 3',
    name: 'Safe Home Checklist',
    icon: '🏠',
    color: 'bg-indigo-500/20 border-indigo-500/50'
  }];
  return <section id="visualizacion" className="bg-familia-bg py-16 px-4 md:px-6" data-id="element-193">
      <div className="max-w-7xl mx-auto text-center" data-id="element-194">
        <h2 className="text-3xl md:text-5xl font-display font-bold mb-12" data-id="element-195">
          What Is Included in the{' '}
          <span className="text-familia-cyan" data-id="element-196">Master Kit</span>?
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-197">
          {items.map((item, i) => <div key={i} className={`p-6 rounded-2xl border-2 ${item.color} flex flex-col items-center justify-center transition-transform hover:scale-105 cursor-default`} data-id="element-198">
              <span className="text-4xl md:text-5xl mb-4" data-id="element-199">{item.icon}</span>
              <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-white/60 mb-1" data-id="element-200">
                {item.title}
              </span>
              <span className="text-sm md:text-base font-bold leading-tight" data-id="element-201">
                {item.name}
              </span>
            </div>)}
        </div>

        <div className="mt-16 relative max-w-4xl mx-auto" data-id="element-202">
          <div className="absolute inset-0 bg-familia-cyan/20 blur-[100px] rounded-full" data-id="element-203" />
          <img src="https://cdn.magicpatterns.com/uploads/uwykjFyFCZkUZdBL5N4q8w/ChatGPT_Image_15_jun_2026__02_53_38_p.m.-removebg-preview.png" alt="Vitality 360 Master Kit Overview" className="relative z-10 w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-204" />
        </div>
      </div>
    </section>;
};